import { get, isEmpty } from "lodash"
import { createSelector } from "reselect"

const getUserInfo = (state) => get(state, "global.data.activateAccountUser.data")

export const getSsoActivationToken = (state) => get(state, "global.data.activateAccountUser.data.ssoActivationToken")
export const getToken = (_, props) => get(props, "params.token")

export const getValidToken = createSelector(
  [getUserInfo, getToken],
  (userInfo, token) => {
    if (isEmpty(userInfo) || !userInfo.email) {
      return null
    }
    return token
  })

export const getUserName = createSelector(
  [getUserInfo],
  (userInfo) => get(userInfo, "name"),
)

export const getUserEmail = createSelector(
  [getUserInfo],
  (userInfo) => get(userInfo, "email"),
)
